import React, { Fragment, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom"; //React routes
import { useDispatch, useSelector } from "react-redux"; //Hooks de redux
import {
  Typography, //Textos
  useMediaQuery,
  CircularProgress,
  Box,
  Grid,
  IconButton,
  styled,
  useTheme,
} from "@mui/material"; //Se importan elementos de la librería material-ui
// import 'videojs-record/dist/css/videojs.record.css'
// import Record from 'videojs-record/dist/videojs.record.js'
import Marquee from "react-fast-marquee";
import DeviceOrientation, { Orientation } from "react-screen-orientation";
import { WarningRounded } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";

import IconDetener from "../../assets/icons/IconDetener.png";
import IconGrabar from "../../assets/icons/IconGrabar.png";
import IconReproducir from "../../assets/icons/IconReproducir.png";
import IconREC from "../../assets/icons/IconREC.png";

import { CustomCameraVideo } from "../../components/Camera/CustomCameraVideo.js";
import { StopWatch } from "../../components/Cronometro/StopWatch.js";
import { VideoPlayer } from "../../components/VideoPlayer/VideoPlayer.js";
// import { mainStyles, theme } from '../../styles'
import {
  fileActions,
  documentsActions,
  documentsActionsAsync,
  addTitleLegoCurrent,
  workflowActions,
} from "../../store/actions/index.js"; //Acciones de redux necesarioas en el stage
// import { useStyles } from './EvidenceStyles'//Estílos específicos de los elementos de este componente
import { coreFunctions } from "../../utils/index.js"; //Funciones genéricas
// import { evidenceFunctions } from './EvidenceFunctions'
import {
  CustomLoadingOverlay,
  Buttons,
  GenericDialog,
  GenericContainer,
  Alert,
} from "../../components/index.js";
import { blobToBase64, B64toBlob } from "../../utils/index.js";
import VisorPDF from "../../components/Visor/VisorPDF.js";
import { useTranslation } from "react-i18next";

const useStylesInt = makeStyles((theme) => ({
  //Estílos solamente del componente "LoginComponent"
  paperResponsive: {
    display: "flex",
    padding: 8,
    flexWrap: "wrap",
    alignContent: "flex-start",
    borderLeft: `1.8px solid ${theme.palette.secondary.main60}`,
    minHeight: 690,
    [theme.breakpoints.down("sm")]: {
      borderLeft: `0px solid ${theme.palette.secondary.main60}`,
      padding: 7,
      minHeight: "auto",
    },
  },
  botonReponsive: {
    zIndex: 50,
    minWidth: "70%",
    [theme.breakpoints.down("sm")]: {
      minWidth: "100%",
    },
  },
  marqueeCustom: {
    backgroundColor: "#F5F5F5 !important",
    padding: "6px",
    // overflowX: 'none !important',
    borderrounded: "12px !important",
    fontSize: "20px !important",
    height: "60px !important",
    overflowY: "hidden !important",
    ["@media only screen and (max-width: 812px)"]: {
      width: "100% !important",
    },
    width: "100%",
  },
}));

const ContainerCamera = styled(Box)(({ theme }) => ({
  background: "#FFFFFF",
  margin: "0px",
  marginBottom: "0px",
  width: "100%",
  [theme.breakpoints.down("sm")]: {
    minHeight: "50vh",
  },
  overflowY: "hidden !important",
  border: "1px solid green",
  borderRadius: "5px",
}));

const ContainerVideoFrame = styled(Grid)(({ theme }) => ({
  margin: "0px 45px 0px 0px",
  display: "grid !important",
  gridTemplateColumns: "10% 80% 10%",
  gridAutoRows: "100vh !important",
  overflowY: "hidden !important",
  "&::-webkit-scrollbar": {
    width: "0",
    background: "transparent",
  },
  overflowX: "hidden",
  position: "fixed",
  top: 0,
  bottom: 0,
  width: "100%",
  [theme.breakpoints.down("sm")]: {
    gridTemplateColumns: "100%",
  },
}));

const RootVideoStyle = styled(Box)(({ theme }) => ({
  backgroundColor: "#FFFFFF",
  width: "100%",
  display: "flex",
  padding: 0,
  flexWrap: "wrap",
  alignContent: "flex-start",
  [theme.breakpoints.down("sm")]: {
    padding: 7,
    minHeight: "auto",
  },
}));

export default function Evidence(props) {
  const navigate = useNavigate(); //Módulo "History" de react router
  const classes = useStylesInt();
  const localStyles = {}; //useStyles()
  const theme = useTheme();
  const location = useLocation();

  const ProgressBarRef = React.useRef(null);
  const buttonRecRef = React.useRef(null);

  const [loadView, setLoadView] = useState(false);
  const [fileId, setFileId] = useState(0);
  const [remaining, setRemaining] = useState(0);
  const [playMarquee, setPlayMarquee] = useState(false); //descmntr
  // const [playMarquee, setPlayMarquee] = useState(true);
  const [loadMarquesina, setLoadMarquesina] = useState(false);
  const [loadViewNew, setLoadViewNew] = useState(0);
  const [marqueeText, setMarkeeText] = useState("INSTRUCCIONES");
  const [evidenceDate, setEvidenceDate] = useState("");
  const [auditoText, setAudioText] = useState("");

  const [lat, setLat] = useState("");
  const [lon, setLon] = useState("");
  // const [videoDataObj, setVideoDataObj] = useState();
  // const [nameVideoRecord, setNameVideoRecord] = useState("");
  // const localStyles = {}//useStyles();

  const [vetanaVideo, setVetanaVideo] = useState(0);

  const dateCurrent = new Date();
  const [playing, setPlaying] = useState(false);
  const [playingActive, setPlayingActive] = useState(false);
  const [recording, setRecording] = useState(false);
  const [blobVideo, setBlobVideo] = useState(null);
  const [nameDoc, setNameDoc] = useState(null);
  const [cronometroTimer, setCronometroTimer] = useState(0);
  const [stopRecording, setStopRecording] = useState(false);
  const [lengtVideo, setLengtVideo] = useState(null);
  const [currentTime, setCurrentTime] = useState(null);

  const [currentFile, setCurrentFile] = useState(0);
  const [totalFiles, setTotalFiles] = useState(0);

  const [uploadDocSectionContent, setUploadDocSectionContent] = useState(false);
  const [saveContinue, setSaveContinue] = useState(false);
  const [activeGeolocalizacionEvidence, setActiveGeolocalizacionEvidence] =
    useState(false);
  const [fileInfoLoad, setFileInfoLoad] = useState(false);
  const [isFirstLoad, setFirstLoad] = useState(true);
  const [saveVideo, setSaveVideo] = useState(false);
  const [loadFileText, setLoadFileText] = useState(false);
  const [fileName, setFileName] = useState("Cargando documentos");
  const [responsePdf, setResponsePdf] = useState("");

  const [timerSeconds, setTimerSeconds] = useState(30);
  const [imageCounter, setImageCounter] = useState(0);
  const [listDocuments, setListDocuments] = useState([]);

  const [maxLengthRecording, setMaxLengthRecording] = useState(60);
  const { t } = useTranslation();

  //Redux hooks
  const auth = useSelector((state) => state.Authentication);
  const wf = useSelector((state) => state.Workflow);
  const fileText = useSelector((state) => state.FileText);
  const file = useSelector((state) => state.FileInfo);
  const uploadDocSecContent = useSelector(
    (state) => state.UploadDocSectionContent
  );
  // const document = useSelector(state => state.Document)
  const documentUpEvidence = useSelector(
    (state) => state.DocumentUploadEvidence
  );
  const dispatch = useDispatch(); //constate dispatch que ejecutará las acciones

  // Dispose the Video.js player when the functional component unmounts
  useEffect(() => {
    dispatch(addTitleLegoCurrent(t("video_evidency_title")));
    setFileId(location.state.folioId);
    dispatch(fileActions.GetFileInfo(location.state.folioId));
    setFileInfoLoad(true);
    setTimeout(() => {
      console.log("INIAGRABACION");
      actionsButtons("Grabar");
    }, 4000);
  }, []);

  useEffect(() => {
    setLoadView(file.loading);
    console.log("File: ", file.items);
    if (file.items != undefined && !isFirstLoad) {
      if (file.items.Product == "Solicitud Grupal") {
        setActiveGeolocalizacionEvidence(true);
      }
      //Enviar a siguiente componente definido en el nucleo
      let nextStage = file.items.Stage;
      let stageName = file.items.Stage.Name;
      let stageId = file.items.Stage.Id;
      let stage = file.items;
      let folioId = file.items.Id;
      let nextComponent = coreFunctions.GetLegoNext(stageName);
      console.log("FILEINFOOOOOOOOOOOO", file.items);
      coreFunctions.DoNextStage({
        navigate,
        nextComponent,
        State: { stageName, stageId, stage, folioId },
      });
    } else if (file.items != undefined && saveVideo) {
      if (file.items.Product == "Solicitud Grupal") {
        setActiveGeolocalizacionEvidence(true);
      }
      //Enviar a siguiente componente definido en el nucleo
      let nextStage = file.items.Stage;
      let stageName = "EvidenciasCheckResult";
      let stageId = file.items.Stage.Id;
      let stage = file.items;
      let folioId = file.items.Id;
      let nextComponent = coreFunctions.GetLegoNext(stageName);
      console.log(
        "FILEINFO: SAVE video---------------Continue-------------------------:  ",
        file.items,
        nextComponent
      );
      coreFunctions.DoNextStage({
        navigate,
        nextComponent,
        State: { stageName, stageId, stage, folioId },
      });
    } else if (file.items != undefined && fileInfoLoad) {
      if (file.items.Product == "Solicitud Grupal") {
        setActiveGeolocalizacionEvidence(true);
      }
      // console.log("File Info ", file.items)
      dispatch(fileActions.GetTextEvidence(file.items.Id));
      setLoadFileText(true);
      setFileInfoLoad(false);

      // file.items.Stage?.Properties MostrarDocumentos
      let mostrarDocs = file.items.Stage?.Properties.find(
        (element) => element.Name == "MostrarDocumentos"
      );

      let docs = file.items.Stage?.DocumentalCategory?.DocumentalGroups;

      if (mostrarDocs?.Value == "1" || mostrarDocs?.Value == 1) {
        console.log("docs?.length**", docs?.length);
        if (docs === undefined || docs === null || docs?.length <= 0) {
          setTimerSeconds(-2);
          setListDocuments(null);
          return;
        }
        let docFind = docs
          ?.find((item) => item.Name == "Identificación oficial")
          ?.DocumentTypes?.find((item) => item.Name == "INE / IFE").Document;
        console.log(
          "docs:--------------docFind--------------------- ",
          docFind
        );

        let idCurrentFind =
          docFind === undefined || docFind === null
            ? docs?.find((item) => item.Name == "Identificación oficial")
                ?.DocumentTypes[0]?.Document?.Id
            : docFind.Id;

        documentsActionsAsync
          .DownloadDocumentAsync(idCurrentFind)
          .then((response) => {
            if (
              response.Body.B64Content.length > 100 &&
              response.Body.FileName.indexOf(".pdf") > 0
            ) {
              const newList = {
                b64: response.Body.B64Content,
                name: response.Body.FileName,
              };
              if (
                listDocuments.some((e) => e.name === response.Body.FileName)
              ) {
                let newArr = listDocuments.map((item) => {
                  if (item.name === response.Body.FileName) {
                    return {
                      b64: response.Body.B64Content,
                      name: response.Body.FileName,
                    };
                  } else {
                    return item;
                  }
                });
                setListDocuments(newArr);
                setTimerSeconds(0);
              } else {
                console.log("Agregar documento: ", listDocuments);
                listDocuments.push(newList);
                setTimerSeconds(0);
              }
            }
          });
        setTimerSeconds(-2);
      } else {
        // console.log("docs view ", docs)
        docs.forEach((docGroups) => {
          // console.log("docGroups", docGroups)
          docGroups.DocumentTypes.forEach((docTypes) => {
            // console.log("docTypes", docTypes)
            let docDocument = docTypes.Document;
            // console.log("docDocument", docDocument)
            if (docDocument != null && docDocument != undefined) {
              documentsActionsAsync
                .DownloadDocumentAsync(docDocument.Id)
                .then((response) => {
                  if (
                    response.Body.B64Content.length > 100 &&
                    response.Body.FileName.indexOf(".pdf") > 0
                  ) {
                    const newList = {
                      b64: response.Body.B64Content,
                      name: response.Body.FileName,
                    };
                    if (
                      listDocuments.some(
                        (e) => e.name === response.Body.FileName
                      )
                    ) {
                      let newArr = listDocuments.map((item) => {
                        if (item.name === response.Body.FileName) {
                          return {
                            b64: response.Body.B64Content,
                            name: response.Body.FileName,
                          };
                        } else {
                          return item;
                        }
                      });
                      setListDocuments(newArr);
                    } else {
                      listDocuments.push(newList);
                    }
                  }
                });
            }
          });
        });
      }
      // console.log("finish docs view ", docs)
      setTimerSeconds(2);
    }
  }, [file]);

  useEffect(() => {
    setLoadView(fileText.loading);
    if (fileText.items != undefined && loadFileText) {
      setLoadFileText(false);
      console.log("fileText:---------EVIDENCE--- ", fileText);
      setEvidenceDate(fileText.items.EvidenceDate);
      setAudioText(fileText.items.TextAudioEvidence);
      setMarkeeText(fileText.items.TextVideoEvidence);
      setLoadMarquesina(true);
    } else if (fileText.error != undefined && loadFileText) {
      setLoadFileText(false);
      console.log("Error: ", fileText.error);
    }
  }, [fileText]); //Ejecutará el contenido de useEffect cada vez que 'file' se actualice

  useEffect(() => {
    if (timerSeconds == 0) {
      //Realiza la peticion
      if (imageCounter < listDocuments.length - 1) {
        setImageCounter(imageCounter + 1);
      } else setImageCounter(0);

      if (listDocuments.length > 0) {
        let pdfB64 = listDocuments[imageCounter]?.b64;
        const blob = B64toBlob(pdfB64, "application/pdf");
        // console.log("Nlob object------------------------------*******************: ", blob)
        const blobUrl = URL.createObjectURL(blob);
        // console.log("Nlob blobUrl------------------------------*******************: ", blobUrl)
        setResponsePdf(<VisorPDF pdfUrl={blobUrl} />);

        setTotalFiles(listDocuments.length);
        setFileName(listDocuments[imageCounter]?.name);
        // setFileCurrentB64(`data:application/pdf;base64,${listDocuments[imageCounter].b64}`)
        if (listDocuments.length > 1) {
          setCurrentFile(imageCounter + 1);
        }
        if (imageCounter == listDocuments.length - 1) {
          setImageCounter(0);
        }
        if (timerSeconds == 0) {
          setTimerSeconds(5);
        }
      } else {
        setTimerSeconds(1);
        // console.log("No entro al if imageCounter: ", imageCounter)
        // console.log("No entro al if: ", listDocuments)
      }
    }
    // salir cuando lleguemos a 0
    if (!timerSeconds) return;

    // save intervalId para borrar el intervalo cuando el componente vuelve a renderizar
    const intervalId = setInterval(() => {
      setTimerSeconds(timerSeconds - 1);
    }, 1500);

    // clear interval al volver a renderizar para evitar pérdidas de memoria
    return () => clearInterval(intervalId);
  }, [timerSeconds]);

  useEffect(() => {
    // console.log("Carga de evidencia: Response - ", documentUpEvidence)
    setLoadView(documentUpEvidence.loading);
    if (documentUpEvidence.items != undefined && saveContinue) {
      let documentSectionId =
        documentUpEvidence.items.Result.VideoEvidence.DocumentSection_Id;

      let requestSecContent = {
        DocumentSection_Id: documentSectionId,
        B64Data: blobVideo,
        fileName: nameDoc,
      };
      console.log(
        "requestSecContent-----------------Envio de video grabacion*******************---------------------: ",
        requestSecContent
      );
      // dispatch(documentsActions.UploadDocumentSectionContent(requestSecContent))
      dispatch(
        documentsActions.UploadVideoEvidenceContentJsonResult(requestSecContent)
      ); //HERE
      dispatch(workflowActions.ContinueWorkflowAction({}, true));
      setSaveContinue(false);
      setUploadDocSectionContent(true);
      dispatch(fileActions.GetFileInfo(fileId));
      setSaveVideo(true);
    } else if (documentUpEvidence.error != undefined && saveContinue) {
      setSaveContinue(false);
      setUploadDocSectionContent(false);
      Alert({
        icon: "error",
        title: documentUpEvidence.error,
      });
    }
  }, [documentUpEvidence]);

  /* useEffect(() => {
    setLoadView(uploadDocSecContent.loading)
    if (uploadDocSecContent.items != undefined && uploadDocSectionContent) {
      // dispatch(fileActions.GetFileInfo(fileId))
      // setSaveVideo(true)
      setUploadDocSectionContent(false)
    } else if (uploadDocSecContent.error != undefined && uploadDocSectionContent) {
      setUploadDocSectionContent(false)
    }
  }, [uploadDocSecContent]); */

  useEffect(() => {
    console.log("stopRecording--------------------: ", stopRecording)
    if (stopRecording) {
      actionsButtons("Detener");
    }
  }, [stopRecording]);

  useEffect(() => {
    console.log(
      "File Stage file.items?.Stage?.Properties: ",
      file.items?.Stage?.Properties
    );
    if (
      file.items?.Stage?.Properties?.filter(
        (item) => item.Name == "MaxLengthRecording"
      )?.length > 0
    ) {
      let timeCurrentProp = file.items?.Stage?.Properties.filter(
        (item) => item.Name == "MaxLengthRecording"
      )[0]?.Value;
      console.log(
        "File Stage file.items?.Stage?.Properties:  MaxLengthRecording ",
        timeCurrentProp
      );
      setMaxLengthRecording(timeCurrentProp);
    }
  }, [file.items?.Stage?.Properties]);
  // let onDocumentLoadSuccess = (numPages) => {
  //   setPageNumber(1);
  // }

  //Método controlador de reenvió de pin o edición de datos
  let handleSend = (e) => {
    e.preventDefault();
    console.log("SIM", "si");
    enviarDatos();
  };

  let enviarDatos = () => {
    // console.log("activeGeolocalizacionEvidence---------------: ", activeGeolocalizacionEvidence)
    if (activeGeolocalizacionEvidence) {
      let folioId = file.items.Id;
      let audiob64 = null;
      let textAudio = auditoText;
      let textVideo = marqueeText;
      let dateEvidence = evidenceDate;
      let videob64 = blobVideo;
      let nameVideo = nameDoc;

      let nextComponent = "LocationEAudioComponent";
      console.log(
        "nextComponent-------: ",
        nextComponent,
        folioId,
        audiob64,
        textAudio,
        textVideo,
        dateEvidence,
        videob64,
        nameVideo
      );
      coreFunctions.DoNextStage({
        navigate,
        nextComponent,
        State: {
          folioId,
          audiob64,
          textAudio,
          textVideo,
          dateEvidence,
          videob64,
          nameVideo,
        },
      });
    } else {
      let requestDocEvidence = {
        AudioEvidence: { B64Content: "", Extension: "" },
        ContinueWorkFlow: false,
        ObjectId: fileId,
        VideoEvidence: { B64Content: "", Extension: "", DeferLoad: true },
        Geolocation: { Latitude: "0.12", Longitude: "19.7" },
        TextVideoEvidence: marqueeText,
        TextAudioEvidence: auditoText,
        VideoEvidenceDate: evidenceDate, //Se obteiene de la configuracion del stage
        AudioEvidenceDate: null,
        LivenessEvidence: {
          B64Content: "",
          Extension: "",
          DeferLoad: false,
        },
        TrackingData: {
          IMEI: "FC:01:7C:45:48:3F", // Todo: Este si va MAC o DeviceID
          Reference: "",
        },
      };
      console.log(
        "requestDocEvidence----------------------FlowNormal---------------: ",
        requestDocEvidence
      );
      dispatch(documentsActions.documentUploadEvidence(requestDocEvidence)); // HERE
      setSaveContinue(true);
    }
  };

  const actionsButtons = (type) => {
    switch (type) {
      case "Reproducir":
        setPlayingActive(!playingActive);
        setPlayMarquee(false);
        break;
      case "Detener":
        setRecording(false);
        setPlaying(true);
        setRemaining(1);
        setPlayMarquee(false);
        break;
      case "Grabar":
        setRecording(true);
        setPlaying(false);
        setBlobVideo(null);
        setRemaining(0);
        setPlayMarquee(true);
        setStopRecording(null);
        break;
      default:
        setRecording(true);
        setPlaying(false);
        setBlobVideo(null);
        setRemaining(0);
        setPlayMarquee(true);
    }
  };

  return (
    <GenericContainer>
      {/* <DeviceOrientation className={localStyles.deviceOrientationContent} lockOrientation={'landscape'}  >
      <Orientation orientation='landscape' alwaysRender={false}  > */}
      <RootVideoStyle>
        {loadView ? (
          <CustomLoadingOverlay
            active={loadView}
            text={t("general_loading_message")}
          />
        ) : null}
        {/* <Box sx={{ width: '40%', display: "flex", justifyContent: "center", alignItems: 'center', flexDirection: 'column' }}>
            {console.log("listDocuments", listDocuments)}
            {listDocuments === null ? <Typography variant="subtitle1" gutterBottom className={localStyles.titleDoc}>Sin documentos a mostrar</Typography> : <>
              <Typography variant="subtitle1" gutterBottom className={localStyles.titleDoc}>{fileName}</Typography>
              {responsePdf == "" ? <CircularProgress className={localStyles.CircleProgress} /> : responsePdf}
              <Typography variant="subtitle1" gutterBottom className={localStyles.titleDoc}>{totalFiles > 0 ? (totalFiles == currentFile ? 1 : (currentFile + 1)) : 0}/{totalFiles}</Typography>
          
            </>}
          </Box> */}
        {/* <Box sx={{ width: '60%' }}> */}

        <Box sx={{ p: 1, width: "100%", overflow: "auto" }}>
          <ContainerCamera>
            <Box
              sx={{
                display: "grid !important",
                gridTemplateColumns: "50% 50%",
                width: "100%",
                alignItems: "center",
                backgroundColor: "#000000",
                top: "0px",
                paddingTop: "5px",
                paddingBottom: "3px",
                position: "sticky",
                zIndex: 25,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  zIndex: 25,
                  paddingLeft: "15px",
                  // fontFamily: 'Montserrat',
                  fontStyle: "normal",
                  fontWeight: 500,
                  color: "#F3F3F3",
                  fontSize: "13px",
                  lineHeight: "130%",
                }}
              >
                {dateCurrent.toLocaleString()}
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  paddingRight: "20px",
                  zIndex: 25,
                }}
              >
                {recording ? (
                  <img style={{ height: "2vh" }} alt="rec" src={IconREC} />
                ) : null}
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                justifyContent: "flex-start",
                alignItems: "center",
                height: "50vh",
                overflow: "hidden",
              }}
            >
              {vetanaVideo === 1 || vetanaVideo == 0 ? (
                //  navigator.userAgent.match(/iPhone/i)?
                //  <div>camara no soportada</div>
                //  :
                <CustomCameraVideo
                  width={700}
                  isDisplay={playing ? false : true}
                  onCapture={(blob) => {
                    console.log("blob video: ", blob);
                    setBlobVideo(blob);
                    let dateNow = new Date();
                    let name = `${dateNow.getDate()}${dateNow.getMonth()}${dateNow.getFullYear()}_${dateNow.getHours()}${dateNow.getMinutes()}${dateNow.getSeconds()}_capture.webm`;
                    console.log("Name de generic", name);
                    setNameDoc(name);
                  }}
                  Recording={recording}
                  setStopRecording={setStopRecording}
                  Stopped={playing}
                  myVal={playing}
                />
              ) : null}

              {console.log(
                "blobVideo",
                playing,
                blobVideo,
                playing && !navigator.userAgent.match(/iPhone/i),
                navigator.userAgent.match(/iPhone/i)
              )}
              {playing && blobVideo != null ? (
                <VideoPlayer
                  Playing={playingActive}
                  src={URL.createObjectURL(blobVideo)}
                  setLengtVideo={setLengtVideo}
                  setCurrentTime={setCurrentTime}
                  ProgressBar={ProgressBarRef.current}
                />
              ) : playing && !navigator.userAgent.match(/iPhone/i) ? (
                <CircularProgress
                  size={60}
                  sx={{ margin: "auto", display: "flex" }}
                />
              ) : (
                <div>{``}</div>
              )}
            </Box>
            {/* botones middle*/}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  width: "auto",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 25,
                  backgroundColor: "rgba(203, 202, 202, 0.2)",
                  position: "absolute",
                  top: "30vh",
                  height: "auto",
                }}
              >
                {!recording ? (
                  <IconButton
                    ref={buttonRecRef}
                    style={{ margin: 10, padding: 2, width: 50, height: 50 }}
                    title={t("applicant_recording")}
                    color="secondary"
                    id={"btn_record_evidence"}
                    onClick={() => {
                      actionsButtons("Grabar");
                    }}
                  >
                    <img alt="Gabar" src={IconGrabar} />
                  </IconButton>
                ) : null}
                {playing ? (
                  <IconButton
                    id={"btn_play_evidence"}
                    style={{ margin: 10, padding: 2, width: 50, height: 50 }}
                    title={t("applicant_start")}
                    color="secondary"
                    onClick={() => {
                      actionsButtons("Reproducir");
                    }}
                  >
                    <img alt="Reproducir" src={IconReproducir} />
                  </IconButton>
                ) : null}
                {recording ? (
                  <IconButton
                    id={"btn_stop_evidence"}
                    style={{ margin: 10, padding: 2, width: 50, height: 50 }}
                    title={t("applicant_stop")}
                    color="secondary"
                    onClick={() => {
                      actionsButtons("Detener");
                    }}
                  >
                    <img alt="Detener" src={IconDetener} />
                  </IconButton>
                ) : null}
              </Box>
            </Box>
            {/* botones bottom */}
            <Box
              sx={{
                display: "grid !important",
                gridTemplateColumns: "50% 50%",
                width: "100%",
                alignItems: "center",
                position: "sticky",
                zIndex: 25,
                backgroundColor: "#D9D9D9",
                bottom: "0px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                  justifyContent: "flex-start",
                  paddingLeft: "15px",
                  alignItems: "center",
                  zIndex: 25,
                }}
              ></Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                  alignItems: "center",
                  zIndex: 25,
                  paddingRight: "20px",
                  // fontFamily: 'Montserrat',
                  justifyContent: "flex-end",
                  fontStyle: "normal",
                  fontWeight: 500,
                  fontSize: "10px",
                  lineHeight: "130%",
                }}
              >
                {recording ? (
                  <StopWatch
                    Recording={recording}
                    Stopped={!recording}
                    MaxLengthRecording={maxLengthRecording}
                    setStopRecording={setStopRecording}
                  />
                ) : (
                  <progress
                    id="progress-bar"
                    ref={ProgressBarRef}
                    min="0"
                    max="100"
                    value="0"
                  ></progress>
                )}
              </Box>
            </Box>
          </ContainerCamera>
          {/* {console.log("remaining, loadMarquesina, playMarquee: ", remaining, loadMarquesina, playMarquee)} */}
          {remaining == 0 && loadMarquesina && playMarquee ? (
            <Marquee
              className={classes.marqueeCustom}
              direction="left"
              gradient={false}
              speed={105}
              delay={3}
              gradientWidth={10}
              play={playMarquee}
              pauseOnHover={false}
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: `${marqueeText} ${"&nbsp;".repeat(1000)}`,
                }}
              ></div>
            </Marquee>
          ) : null}
        </Box>
        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
          {remaining != 0 && blobVideo != null ? (
            <Buttons onClickConfirm={handleSend} />
          ) : null}
        </Box>
        {/* </Box> */}
      </RootVideoStyle>
      {/* </Orientation>
      <Orientation orientation='portrait' alwaysRender={false}>
    <div className={localStyles.warningContent}>
      <div style={{ width: '100% !important' }}>
        <WarningRounded className={localStyles.warningAlert} />
      </div>
      <div style={{ width: '100% !important' }}>
        <Typography variant="subtitle1" gutterBottom className={localStyles.titleDoc}>Para continuar gira el dispositivo</Typography>
      </div>
    </div>
    </Orientation>
    </DeviceOrientation> */}
    </GenericContainer>
  );
}
